import React, { useState, useEffect } from "react";
import Layout from "../../../Components/Layout/layout";
import dashboardclasses from "../../dashboard.module.css";
import { css } from "@emotion/react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Services } from "../../../Services";
import { toast } from "react-toastify";

import { useNavigate, useParams } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import Styles from "./Styles.module.css";

import WalletAdjustment from "../WalletAdjustment/Adjustment";

function Products() {
    const headerstyles = {
        color: "#707275",
        fontWeight: 700,
        fontSize: "0.8rem",
    };
    const Navigate = useNavigate();
    const { id } = useParams();

    let [loading, setLoading] = useState(true);

    const [users, setUser] = useState([]);
    const [Adjustment, setAdjustment] = useState(false);
    const [WalletTransactions, setWalletTransactions] = useState([]);
    const [booking, setBookings] = useState([]);
    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const tableRowEvents = {
        onClick: (e, row, rowIndex) => {
            e.preventDefault();
            Navigate(`/booking-Order-details/${row.booking_id}/${row.type}`);
        },
    };
    const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
    `;
    const getorders = () => {
        Services.getUserDetails("GET", null, token, id)
            .then((res) => {
                console.log(res);
                setLoading(false);
                if (res.Status === 1) {
                    // setOrdersSearch(res.Orders);
                    setUser(
                        res?.Users && res?.Users?.length > 0
                            ? res?.Users[0]
                            : {}
                    );
                    setBookings(res?.Bookings);
                    setWalletTransactions(res?.WalletTransactions);
                } else if (res.Status === 0) {
                    toast.error(`${res.Message}`, {
                        position: "top-center",
                        autoClose: 1000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    if (res.Message === "Token expired") {
                        Navigate("/");
                    }
                }
            })
            .catch((err) => {
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        getorders();
        // eslint-disable-next-line
    }, []);

    let column3 = [
        {
            dataField: "razorpay_order_id",
            text: "RazorPay ID",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "amount",
            text: "Amount",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "createdAtFormatted",
            text: "Transaction Date",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },

        {
            dataField: "notes",
            text: "Notes",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "transaction_type",
            text: "Status",
            sort: false,
            formatter: (cell, cellContent) => (
                <p
                    className={
                        cell == 1 ? Styles["completed"] : Styles["pending"]
                    }>
                    {" "}
                    {cell == 1 ? "Credit" : "Debit"}
                </p>
            ),
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
    ];
    const emptyDataMessage = () => {
        return "No Data to Display";
    };
    const defaultSorted = [
        {
            dataField: "name",
            order: "desc",
        },
    ];
    const Idformatter = (cell, cellcontent, index, formatExtraData) => {
        return (
            <div>
                <p className={dashboardclasses["idformatter"]}>{cell}</p>
            </div>
        );
    };
    const priceFormatter = (cell) => {
        //className={dashboardclasses["priceformatter"]}
        return (
            <div className={dashboardclasses["price-wrapper"]}>
                <p>₹ {cell}</p>
            </div>
        );
    };
    let columns = [
        {
            dataField: "booking_id",
            text: "BOOKING ID",
            sort: false,
            // cell: (row, index) => index + 1,
            formatter: Idformatter,
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },
        {
            dataField: "user_mobile",
            text: "USER",
            sort: false,
            formatter: (cell, cellContent) => {
                return (
                    <>
                        {cellContent.name},<br />
                        {cell}
                    </>
                );
            },
            // cell: (row, index) => index + 1,
            headerStyle: (colum, colIndex) => {
                return {
                    ...headerstyles,
                };
            },
        },

        {
            dataField: "ADDRESS",
            text: "PICK UP ADDRESS",
            sort: false,
            formatter: (cell, cellContent) => (
                <>
                    {cellContent?.main_pickup_address?.areaName} <br />
                    {cellContent?.main_pickup_address?.buildingName} <br />
                    {cellContent?.main_pickup_address?.city} <br />
                    {cellContent?.main_pickup_address?.pincode}
                </>
            ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "ADDRESS",
            text: "DROP ADDRESS",
            sort: false,
            formatter: (cell, cellContent) => (
                <>
                    {cellContent?.main_drop_address?.areaName} <br />
                    {cellContent?.main_drop_address?.buildingName} <br />
                    {cellContent?.main_drop_address?.city} <br />
                    {cellContent?.main_drop_address?.pincode}
                </>
            ),
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "transport_name",
            text: "TRANSPORT",
            sort: false,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },

        {
            dataField: "book_date",
            text: "BOOK DATE",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "start_time_formatted",
            text: "START TIME",
            sort: false,
            formatter: (cell, cellContent) => cell,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "end_time_formatted",
            text: "END TIME",
            sort: false,

            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "grand_total",
            text: "RIDE FARE",
            sort: false,
            formatter: priceFormatter,
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
        {
            dataField: "payment_method",
            text: "PAYMENT",
            sort: false,
            formatter: (cell) =>
                !cell
                    ? ""
                    : cell == 1
                    ? "CASH"
                    : cell == 2
                    ? "ONLINE"
                    : "WALLET",
            headerStyle: (colum, colIndex) => {
                return { ...headerstyles };
            },
        },
    ];
    return (
        <>
            <Layout Active={"Users_mobility"}>
                {Adjustment && (
                    <WalletAdjustment
                        isOpen={Adjustment}
                        setisOpen={setAdjustment}
                        id={id}
                        refetch={() => getorders()}
                    />
                )}

                <div className={dashboardclasses["dashboard-rightside"]}>
                    <div className={dashboardclasses.CategoryWrapper}>
                        {loading ? (
                            <div className={dashboardclasses["loader"]}>
                                <ScaleLoader
                                    color={"black"}
                                    loading={true}
                                    css={override}
                                    size={150}
                                />
                            </div>
                        ) : (
                            <>
                                <button
                                    className={dashboardclasses["backbutton"]}
                                    onClick={() => {
                                        Navigate(-1);
                                    }}>
                                    Back
                                </button>
                                <header
                                    className={
                                        dashboardclasses["order-details-header"]
                                    }>
                                    <h3
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.5rem",
                                        }}>
                                        User Details{" "}
                                    </h3>
                                </header>
                                <div
                                    className={
                                        dashboardclasses[
                                            "orders-form-invoice-wrapper"
                                        ]
                                    }>
                                    <div
                                        className={
                                            dashboardclasses[
                                                "orders-form-invoice"
                                            ]
                                        }>
                                        <div
                                            className={
                                                dashboardclasses["order-items"]
                                            }>
                                            <header
                                                className={
                                                    dashboardclasses[
                                                        "customer-info-header"
                                                    ]
                                                }>
                                                <h4>
                                                    User Info{" "}
                                                    <button
                                                        style={{
                                                            fontSize: "1rem",
                                                            marginLeft: "1rem",
                                                        }}
                                                        onClick={() =>
                                                            setAdjustment(true)
                                                        }
                                                        className={
                                                            dashboardclasses[
                                                                "red"
                                                            ]
                                                        }>
                                                        Wallet Adjustment
                                                    </button>
                                                </h4>
                                            </header>

                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: "1rem",
                                                    flexWrap: "wrap",
                                                    alignContent: "center",
                                                    // width: "100%",
                                                    justifyContent:
                                                        "space-between",
                                                }}>
                                                <div
                                                    className={
                                                        dashboardclasses[
                                                            "order-item-data"
                                                        ]
                                                    }
                                                    style={{ flexGrow: "1" }}>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Name</h5>
                                                        <h4>:</h4>
                                                        <p>{users.name} </p>
                                                    </div>

                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Contact Number</h5>
                                                        <h4>:</h4>
                                                        <p>{users.mobile}</p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Email</h5>
                                                        <h4>:</h4>
                                                        <p> {users.emailid}</p>
                                                    </div>

                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>wallet Amount</h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            Rs.{" "}
                                                            {users.walletAmount}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>
                                                            Ride Wallet Balance
                                                        </h5>
                                                        <h4>:</h4>
                                                        <p>
                                                            {" "}
                                                            Rs.{" "}
                                                            {
                                                                users.rideWalletBalance
                                                            }
                                                        </p>
                                                    </div>
                                                    <div
                                                        className={
                                                            dashboardclasses[
                                                                "order-date"
                                                            ]
                                                        }>
                                                        <h5>Address</h5>
                                                        <h4>:</h4>
                                                        <p>{users?.city},</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <h3 style={{ marginTop: "1rem" }}>
                                            {" "}
                                            Wallet Transactions
                                        </h3>
                                        <div className="category-table">
                                            <BootstrapTable
                                                bootstrap4
                                                keyField="id"
                                                data={WalletTransactions}
                                                columns={column3}
                                                defaultSorted={defaultSorted}
                                                // pagination={pagination}
                                                wrapperClasses="table-responsive"
                                                noDataIndication={
                                                    emptyDataMessage
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="category-table">
                                    <h3 style={{ padding: "0.5rem" }}>
                                        Bookings
                                    </h3>
                                    <BootstrapTable
                                        bootstrap4
                                        keyField="id"
                                        data={booking}
                                        columns={columns}
                                        defaultSorted={defaultSorted}
                                        // pagination={pagination}
                                        wrapperClasses="table-responsive"
                                        noDataIndication={emptyDataMessage}
                                        rowEvents={tableRowEvents}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default Products;
